import { createApi } from '@reduxjs/toolkit/query/react';
import type { CourtListItemDto, CourtDetailDto } from '@/types';
import { baseQueryWithRetry } from './baseQuery';
import { TAG_COURT } from '@/store/tagTypes';

export const courtsApi = createApi({
  reducerPath: 'courtsApi',
  baseQuery: baseQueryWithRetry,
  tagTypes: [TAG_COURT],
  endpoints: (builder) => ({
    listAllCourts: builder.query<CourtListItemDto[], void>({
      query: () => '/courts',
      providesTags: [{ type: TAG_COURT, id: 'LIST' }],
    }),
    getCourtDetail: builder.query<CourtDetailDto, string>({
      query: (id) => `/courts/detail/${id}`,
      providesTags: (_result, _error, id) => [{ type: TAG_COURT, id }],
    }),
  }),
});

export const { useListAllCourtsQuery, useGetCourtDetailQuery } = courtsApi;
